var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"date-wrapper"},[_c('div',{staticClass:"title"},[_vm._v(_vm._s(_vm.title))]),_c('hr',{style:(("background-color:" + _vm.color))}),_c('div',{staticClass:"date"},[_vm._v(_vm._s(_vm.date))])])}
var staticRenderFns = []

export { render, staticRenderFns }